import React from "react";
import { AiFillInstagram } from "react-icons/ai";
import { TiSocialFacebook, TiSocialLinkedin } from "react-icons/ti";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import "./footer.scss";
import ssd from './ssd_logo.png'
function Footer() {
	return (
		<>
		<div className="footer container-fluid">
			<div className="container">
				<div className="innerFooter row">
					<div className="footerDivs col-lg-4 col-md-12 col-sm-12 col-xs-12">
						<div className="logoDet">
							<div className="logoDivFoot">
								<img alt="logo_ku2fnp.webp"
									className="logo"
									src={"https://res.cloudinary.com/ggi/image/upload/v1637903431/logo_ku2fnp.webp"}
								/>
								<h3>
									Galaxy <br /> Gemological <br /> Institute
								</h3>
							</div>
							<p className="Vision">
								To be a leading source for all knowledge and expertise in gems and jewellery.
							</p>
						</div>
						<div className="socialIcons">
							<a rel="noopener noreferrer" href="https://www.facebook.com/galaxygemologicalinstitute/" target="_blank">
								<TiSocialFacebook />
							</a>
							<a rel="noopener noreferrer"
								href="https://www.instagram.com/p/BwcEU31BmfU/?igshid=1qbzmi331ry43"
								target="_blank"
							>
								<AiFillInstagram />{" "}
							</a>

							<a rel="noopener noreferrer"
								href="https://www.linkedin.com/posts/galaxy-gemological-institute_activity-6584389209035988992-SJjq/"
								target="_blank"
							>
								<TiSocialLinkedin />
							</a>
						</div>
					</div>
					<div className="footerDivs col6 col-lg-2 col-md-6 col-sm-6 col-xs-6">
						<div className="links">
							<p className="footerLink">
								<Link to="/about">About</Link>
							</p>
							<p className="footerLink">
								<Link to="/gemological-education">Education</Link>
							</p>
							<p className="footerLink">
								<Link to="/laboratory/about-ggi-laboratory">Laboratory</Link>
							</p>
							<p className="footerLink">
								<Link to="/gemology/YourBirthStone">Find Your Birth Stone</Link>
							</p>
							<p className="footerLink">
								<Link to="/laboratory/lab-reports">Lab Reports</Link>
							</p>
							<p className="footerLink">
								<Link to="/laboratory/terms-and-conditions">Terms And Conditions</Link>
							</p>
						</div>
					</div>
					<div className="footerDivs col6 col-lg-3 col-md-6 col-sm-12 col-xs-12">
						<div className="links">
							<h4>Karachi</h4>
							<p className="footerLink">
								Ground Floor, Mohan Terrace building Sir Jahangir Kothari Trust Shahra-e-Iraq,
								Saddar, Karachi.
							</p>
						</div>
					</div>
					<div className="footerDivs col-lg-3 col-md-6 col-sm-12 col-xs-12">
						<div>
							<h4>Peshawar</h4>
							<div className="postDiv">
								<p className="postLink">
									2nd Floor, Anwaar Flats , Shah Qabool Colony#2 Namak Mandi , Peshawar .
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
			<div className="copyWriteText">
				<p>© All Right Reserved to Galaxy Gemological Institute</p>
				<p><a href="https://softsyncdev.com/" target="_blank"><img src={ssd}/> Powered By <b>SOFTSYNCDEV</b></a></p>
			</div>
		</>
	);
}

const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
